module.exports = __webpack_public_path__ + "static/media/canal.c0b6e321.ogg";